<template>
	<nav class="navbar navbar-expand-lg " color-on-scroll="500">
		<div class="container-fluid">
			<!-- <a class="navbar-brand" href="#pablo">Marti pcs</a> -->
			<button href="" class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation" @click="menuMobile">
				<span class="navbar-toggler-bar burger-lines"></span>
				<span class="navbar-toggler-bar burger-lines"></span>
				<span class="navbar-toggler-bar burger-lines"></span>
			</button>
			<div class="row only-mobile">
				<div class="col col-sm-10">
					<a href="#" class="nav-link" @click="logout">
						<span class="no-icon">Cerrar sesion</span>
					</a>
				</div>
			</div>
			<div class="collapse navbar-collapse justify-content-end" id="navigation">
				<ul class="nav navbar-nav mr-auto">
					<li class="nav-item">
						<a href="#" class="nav-link" data-toggle="dropdown">
							<span class="d-lg-none">Dashboard</span>
						</a>
					</li>
				</ul>
				<ul class="navbar-nav ml-auto">
					<li class="nav-item">
						<a class="nav-link" href="#pablo">
							<span class="no-icon"></span>
						</a>
					</li>
					<li class="nav-item">
						<a href="#" class="nav-link" @click="logout">
							<span class="no-icon">Cerrar sesion</span>
						</a>
					</li>
				</ul>
			</div>
		</div>
	</nav>	
</template>

<script>
import routeService from '../services/route_service.js';
import LoginService from '../services/login_service.js';
//import ConfigService from '../services/config_service.js';
/*import Vue from 'vue';
const configService = new ConfigService();
const config = configService.getConfig();*/
const loginService = new LoginService();
export default {
		data: function() {
			return {
				cerrado: true,
			}
		},
		methods: { 
			menuMobile() {
				if(window.innerWidth < 991) {
					let menu = document.getElementsByClassName("sidebar")[0];
					this.cerrado = menu.className.indexOf("sidebar-open") == -1;
					if(this.cerrado) {
						menu.className = menu.className.replace(/\bsidebar-close\b/g, "");						
						menu.className = menu.className.trim() + " " + "sidebar-open";
						this.cerrado = false;
					} else {
						menu.className = menu.className.replace(/\bsidebar-open\b/g, "");
						menu.className = menu.className.trim() + " " + "sidebar-close";
						this.cerrado = true;
					}
				}
			},
			logout: function () {
				let _this = this;
				loginService.logout({}).then(function() {
					_this.menuMobile();
					routeService.goToLogin();
				}, function(error) { 
					console.log(error);
					_this.menuMobile();
					routeService.goToLogin();
				});
			}
		}
}
</script>
